import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig, profile } from 'config/config'; // Importing configuration settings

export default class otherExpensesView extends JetView {
    /**
     * Configures the view layout and initializes data.
     * @returns {Object} The layout configuration for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const vthis = this; // Reference to the current instance
        const data = [
            // Initial data for the first grid
            {
                Product: 'DoradoBet',
                Bets: 1000,
                Prize: 500,
            },
        ];
        let totalBets = 0; // Variable to hold total bets
        totalBets = data // Calculate total bets from data
            .map((item) => item.Bets)
            .reduce((prev, curr) => prev + curr, 0);
        let totalPrize = 0; // Variable to hold total prize
        totalPrize = data // Calculate total prize from data
            .map((item) => item.Prize)
            .reduce((prev, curr) => prev + curr, 0);
        var gridProduct1 = {
            // Configuration for the first data grid
            rows: [
                {
                    view: 'datatable',
                    id: 'gridProduct1', // Unique ID for the grid
                    css: 'webix_header_border webix_data_border', // CSS classes for styling
                    autoheight: true, // Automatically adjust height
                    scroll: false, // Disable scrolling
                    columns: [
                        // Column definitions
                        {
                            id: 'Product',
                            header: {
                                text: 'Productos',
                                css: { 'text-align': 'center' },
                            },
                            width: 300,
                        },
                        {
                            id: 'Bets',
                            header: {
                                text: 'Apuestas',
                                css: { 'text-align': 'center' },
                            },
                            width: 125,
                        },
                        {
                            id: 'Prize',
                            header: {
                                text: 'Premios',
                                css: { 'text-align': 'center' },
                            },
                            fillspace: true,
                        },
                    ],
                    data: data, // Initial data for the grid
                },
            ],
        };
        /**
         * Updates the total bets from gridProduct2.
         * @returns {number} The sum of bets.
         */
        function updateSummBets() {
            var summ = 0; // Initialize sum
            $$('gridProduct2').data.each(function (row) {
                // Iterate through each row
                summ += row.Bets * 1 || 0; // Accumulate bets
            });
            return summ; // Return total bets
        }
        /**
         * Updates the total prize from gridProduct2.
         * @returns {number} The sum of prizes.
         */
        function updateSummPrize() {
            var summ = 0; // Initialize sum
            $$('gridProduct2').data.each(function (row) {
                // Iterate through each row
                summ += row.Prize * 1 || 0; // Accumulate prizes
            });
            return summ; // Return total prize
        }
        /**
         * Checks if a value is not empty.
         * @param {string} value - The value to check.
         * @returns {boolean} True if not empty, false otherwise.
         */
        function notEmpty(value) {
            return value != ''; // Return true if value is not empty
        }
        /**
         * Checks if a value is a positive integer.
         * @param {number} value - The value to check.
         * @returns {boolean} True if positive integer, false otherwise.
         */
        function positiveInteger(value) {
            return value >= 0; // Return true if value is non-negative
        }
        var gridProduct2 = {
            // Configuration for the second data grid
            rows: [
                {
                    view: 'datatable',
                    autoConfig: true, // Automatically configure columns
                    id: 'gridProduct2', // Unique ID for the grid
                    editable: true, // Enable editing
                    css: 'webix_header_border webix_data_border', // CSS classes for styling
                    columns: [
                        // Column definitions
                        { id: 'Product', width: 300 },
                        { id: 'Bets', editor: 'text', width: 125 }, // Editable Bets column
                        { id: 'Prize', editor: 'text', fillspace: true }, // Editable Prize column
                    ],
                    header: false, // No header
                    rules: {
                        // Validation rules
                        Bets: positiveInteger, // Bets must be a positive integer
                        Prize: positiveInteger, // Prize must be a positive integer
                    },
                    ready: function () {
                        this.validate(); // Validate data on ready
                    },
                },
            ],
        };
        this.on(this.app, 'updateSummBets', (sum) => {
            // Event listener for updating total bets
            var total = totalBets + updateSummBets(); // Calculate new total
            vthis.app.callEvent('totalIncomesProducts:sum', [{ total }]); // Trigger event with total
        });
        this.on(this.app, 'updateSummPrize', (sum) => {
            // Event listener for updating total prize
            var total = totalPrize + updateSummPrize(); // Calculate new total
            vthis.app.callEvent('totalExpensesProducts:sum', [{ total }]); // Trigger event with total
        });
        return {
            // Return the layout configuration
            rows: [gridProduct1, gridProduct2],
        };
    }
    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        var vthis = this; // Reference to the current instance
        $$('gridProduct2').data.attachEvent(
            // Attach event to data store
            'onStoreUpdated',
            function (id, obj, mode) {
                // Event handler for store updates
                if (mode == 'add' || mode == 'update' || mode == 'delete') {
                    // Check mode
                    if ($$('gridProduct2').validate()) {
                        // Validate data
                        vthis.app.callEvent('updateSummBets', [{}]); // Update total bets
                        vthis.app.callEvent('updateSummPrize', [{}]); // Update total prize
                        vthis.app.callEvent('productsObject', [{}]); // Trigger products object event
                    }
                }
            },
        );
        webix.delay(
            // Delay execution of the following function
            function () {
                vthis.app.callEvent('updateSummBets', [{}]); // Update total bets
                vthis.app.callEvent('updateSummPrize', [{}]); // Update total prize
                vthis.app.callEvent('productsObject', [{}]); // Trigger products object event
            },
            '',
            '',
            200, // Delay duration in milliseconds
        );
        webix // AJAX request to fetch products
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(
                devConfig.geturlApi() + 'Accounting/GetProductsByBetShop', // API endpoint
                '{"BetShopId":' + profile.AgentId + ',"State":"A"}', // Request payload
                {
                    error: function (text, data, XmlHttpRequest) {
                        // Error handler
                        webix.message('Error! '); // Display error message
                    },
                    success: function (text, data, XmlHttpRequest) {
                        // Success handler
                        var resp = JSON.parse(text); // Parse response
                        for (var i = 0; i < resp.Data.length; i++) {
                            // Iterate through response data
                            resp.Data[i].id = resp.Data[i].Id; // Map Id to id
                            resp.Data[i].Product = resp.Data[i].Product; // Map Product
                            resp.Data[i].Bets = 0; // Initialize Bets
                            resp.Data[i].Prize = 0; // Initialize Prize
                            delete resp.Data[i].Id; // Remove unnecessary fields
                            delete resp.Data[i].State;
                            delete resp.Data[i].Name;
                            delete resp.Data[i].Account;
                            delete resp.Data[i].Provider;
                        }
                        $$('gridProduct2').define('data', resp.Data); // Define data for gridProduct2
                    },
                },
            );
    }
}

// FILE DOCUMENTED
